type CropTypeKey = "SOY" | "CORN" | "WINTER_CORN" | "SUGARCANE" | "PASTURE" | "ANY" | "UNKNOWN" | "FOREST" | "RICE" | "COFFEE" | "CITRUS" | "COTTON" | "EUCALYPTUS" | "NO_CROP" | "null";

export const CropType: Record<CropTypeKey, string> = {
  SOY: "SOY",
  CORN: "CORN",
  WINTER_CORN: "WINTER_CORN",
  SUGARCANE: "SUGARCANE",
  PASTURE: "PASTURE",
  ANY: "ANY",
  UNKNOWN: "UNKNOWN",
  FOREST: "FOREST",
  RICE: "RICE",
  COFFEE: "COFFEE",
  CITRUS: "CITRUS",
  COTTON: "COTTON",
  EUCALYPTUS: "EUCALYPTUS",
  NO_CROP: "NO_CROP",
  null: "null",
};

export const CropTypeColor: Record<CropTypeKey, string> = {
  SOY: "#33A02C",
  CORN: "#33A02C",
  SUGARCANE: "#6A3D9A",
  WINTER_CORN: "#FFE14D",
  RICE: "#1F78B4",
  COFFEE: "#E31A1C",
  CITRUS: "#D1FF61",
  COTTON: "#FF61A9",
  EUCALYPTUS: "#FF9414",
  FOREST: "#E3DAC9",
  PASTURE: "#9F8170",
  UNKNOWN: "#778899",
  ANY: "#778899",
  NO_CROP: "#778899",
  null: "#778899"
};


export function getCropTypeColor(cropType: CropTypeKey): string {
  return CropTypeColor[cropType];
}


export function isUndefined(cropType: CropTypeKey | string): boolean {
  return cropType === CropType.UNKNOWN || cropType === CropType.NO_CROP || cropType === CropType.null || cropType === CropType.ANY;
}
